(function () {
  'use strict';

  // Mobile nav toggle
  var toggle = document.getElementById('cr-nav-toggle');
  var links = document.getElementById('cr-nav-links');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      var isOpen = links.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Filter + Search
  var grid = document.getElementById('cr-grid');
  var noResults = document.getElementById('cr-noresults');
  var searchInput = document.getElementById('cr-search');
  var filterButtons = document.querySelectorAll('.cr-filter');
  var activeFilter = 'all';

  function applyFilters() {
    if (!grid) return;
    var cards = grid.querySelectorAll('.cr-card');
    var term = searchInput ? searchInput.value.trim().toLowerCase() : '';
    var visible = 0;

    cards.forEach(function (card) {
      var cat = (card.getAttribute('data-category') || '').toLowerCase();
      var title = (card.getAttribute('data-title') || '').toLowerCase();
      var excerpt = (card.getAttribute('data-excerpt') || '').toLowerCase();

      var matchCat = activeFilter === 'all' || cat === activeFilter;
      var matchSearch = term === '' || title.indexOf(term) !== -1 || excerpt.indexOf(term) !== -1;

      if (matchCat && matchSearch) {
        card.style.display = '';
        visible++;
      } else {
        card.style.display = 'none';
      }
    });

    if (noResults) {
      noResults.hidden = visible > 0;
    }
  }

  filterButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      activeFilter = btn.getAttribute('data-filter') || 'all';
      applyFilters();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

})();
